import classnames from 'classnames';

import './FolderIcon.css';

interface FolderIconProps {
  className?: string;
  size?: number;
}

function FolderIcon({ className, size = 24 }: FolderIconProps) {
  const iconClasses = classnames('folder-icon', className);

  return (
    <svg
      aria-hidden='true'
      className={iconClasses}
      focusable='false'
      height={size}
      role='img'
      viewBox='0 0 37 28'
      width={size}
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M24 28H5.4375H4C1.75 28 0 26.25 0 24V4C0 1.8125 1.75 0 4 0H11.3125C12.375 0 13.375 0.4375 14.125 1.1875L15.8125 2.875C16.5625 3.625 17.5625 4 18.625 4H26C28.1875 4 30 5.8125 30 8V10H27V8C27 7.5 26.5 7 26 7H18.625C16.75 7 15 6.3125 13.6875 5L12 3.3125C11.8125 3.125 11.5625 3 11.3125 3H4C3.4375 3 3 3.5 3 4V20.375L7.25 13C7.625 12.375 8.25 12 9 12H34C34.6875 12 35.375 12.375 35.6875 13C36.0625 13.625 36.0625 14.4375 35.6875 15.0625L28.6875 27.0625C28.3125 27.625 27.6875 28 27 28H24Z'
        fill='currentColor'
      />
    </svg>
  );
}

export default FolderIcon;
